import {Injectable, Renderer2, RendererFactory2} from '@angular/core';
import {BreakpointObserver, BreakpointState, Breakpoints} from '@angular/cdk/layout';
import {Language} from '@shared/enums/language.enum';
import {MediaService} from './media.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class GeneralService {

  isSmallScreen: boolean;
  isMenuOpened: boolean;
  public isRtl: boolean;
  public currentLang;
  private renderer: Renderer2;

  constructor(private mediaService: MediaService,
              rendererFactory: RendererFactory2,
              private translate: TranslateService,
              private breakpointObserver: BreakpointObserver) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.currentLang = localStorage.getItem('lang') as Language;
    this.changeLanguage(this.currentLang || translate.defaultLang);

    const currentTheme = localStorage.getItem('theme');
    if (currentTheme) {
      this.changeTheme(currentTheme);
    }

    this.mediaService.isScreenSmall
      .subscribe(isScreenSmall => {
        this.isSmallScreen = isScreenSmall;
      });
  }

  public getUsersReferredLanguage(): string {
    return this.currentLang;
  }

  public changeLanguage(lang: Language): void {
    this.currentLang = lang;
    localStorage.setItem('lang', lang);
    this.translate.use(lang);
    this.setDirection();
  }

  changeTheme(themeClass: string): void {
    localStorage.setItem('theme', themeClass);
    document.body.className = `mat-typography ${themeClass}`;
  }


  public setDirection(): void {
    const lang = localStorage.getItem('lang');
    this.isRtl = lang === 'he';
    this.renderer.setAttribute(document.body, 'dir', this.isRtl ? 'rtl' : 'ltr')
  }
}
